import React, { Component } from 'react';
import { motion } from 'framer-motion';
import { MessageCircle } from 'lucide-react';
export function Products() {
  const products = [{
    id: 'reishi',
    title: 'Reishi',
    subtitle: 'Equilibrio y bienestar',
    description: 'Extracto funcional ideal para quienes buscan acompañar su rutina de calma, equilibrio y bienestar general.',
    image: 'https://cdn.magicpatterns.com/uploads/3mrW9MjvudfW61TnD8UG2o/hongo3.jpg',
    cta: 'Consultar Reishi'
  }, {
    id: 'cordyceps',
    title: 'Cordyceps',
    subtitle: 'Energía y vitalidad',
    description: 'Una alternativa natural para quienes quieren apoyar su energía diaria y mantener una rutina más activa.',
    image: 'https://cdn.magicpatterns.com/uploads/5PBdgMrkZ4YTPtx7gTzj5e/hongo2.jpg',
    cta: 'Consultar Cordyceps'
  }, {
    id: 'melena',
    title: 'Melena de León',
    subtitle: 'Enfoque y claridad',
    description: 'Extracto funcional asociado a rutinas de concentración, claridad mental y bienestar cognitivo general.',
    image: 'https://cdn.magicpatterns.com/uploads/24uU26LFyRUjes6vSTcjwB/hongo1.jpg',
    cta: 'Consultar Melena de León'
  }];
  return <section className="py-24 bg-brand-beige" id="productos" data-id="element-125">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-126">
        <div className="text-center mb-16" data-id="element-127">
          <motion.h2 initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.6
        }} className="text-3xl md:text-5xl font-heading font-bold text-brand-green" data-id="element-128">
            Conoce nuestros extractos
          </motion.h2>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-8 lg:gap-12" data-id="element-129">
          {products.map((product, index) => <motion.div key={product.id} initial={{
          opacity: 0,
          y: 40
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.6,
          delay: index * 0.15
        }} className="bg-white rounded-3xl overflow-hidden shadow-lg hover:shadow-xl transition-shadow flex flex-col h-full border border-brand-cream" data-id="element-130">
              <div className="aspect-[4/5] overflow-hidden relative" data-id="element-131">
                <img src={product.image} alt={`Extracto de ${product.title}`} className="w-full h-full object-cover transition-transform duration-700 hover:scale-105" data-id="element-132" />
                <div className="absolute top-4 right-4 bg-white/90 backdrop-blur-sm px-3 py-1 rounded-full text-xs font-bold text-brand-green shadow-sm" data-id="element-133">
                  Triple Extracto
                </div>
              </div>

              <div className="p-8 flex flex-col flex-grow" data-id="element-134">
                <h3 className="text-2xl font-heading font-bold text-brand-green mb-1" data-id="element-135">
                  {product.title}
                </h3>
                <p className="text-brand-gold font-medium text-sm mb-4 uppercase tracking-wider" data-id="element-136">
                  {product.subtitle}
                </p>
                <p className="text-brand-brown/70 mb-8 flex-grow leading-relaxed" data-id="element-137">
                  {product.description}
                </p>

                <a href={`https://wa.me/56965576936?text=Hola%2C%20quiero%20informaci%C3%B3n%20sobre%20el%20extracto%20de%20${encodeURIComponent(product.title)}`} target="_blank" rel="noopener noreferrer" className="w-full inline-flex items-center justify-center px-6 py-3.5 bg-brand-green text-white text-sm font-medium rounded-xl hover:bg-brand-lightGreen transition-colors" data-id="element-138">
                  <MessageCircle className="mr-2" size={18} data-id="element-139" />
                  {product.cta}
                </a>
              </div>
            </motion.div>)}
        </div>
      </div>
    </section>;
}